import src from "IMAGE";
export default { src, width: 708, height: 983, blurWidth: 0, blurHeight: 0};
